import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1d68e05d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userLogin" }
const _hoisted_2 = {
  key: 0,
  id: "userPhoneLoginPage"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  id: "userLoginPage"
}
const _hoisted_5 = {
  key: 2,
  id: "userRegisterPage"
}

import { onMounted, reactive, ref } from "vue";
import API from "@/api";
import {
  userLoginUsingPost,
  userRegisterUsingPost,
} from "@/api/userController";
import { useLoginUserStore } from "@/store/userStore";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import {
  codeUsingGet,
  getCodeUsingGet,
  phoneLoginUsingPost,
} from "@/request/api/userController";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLoginPage',
  setup(__props) {

const router = useRouter();
const userStore = useLoginUserStore();

/**
 * 手机号登录
 */
const phoneForm = reactive({
  userPhone: "",
  phoneCode: "",
} as API.UserPhoneRequest);

/**
 * 手机号登录登录
 */
const phoneLogin = async () => {
  const response = await phoneLoginUsingPost(phoneForm);
  if (response.data.code === 0) {
    await userStore.fetchLoginUser();
    message.success("登录成功");
    await router.push({
      path: "/",
      replace: true,
    });
  } else {
    message.error(response.data.message as string);
  }
};
/**
 * 获取手机验证码
 */
const loading = ref(false);
const getPhoneCode = async () => {
  if (phoneForm.userPhone === "" || loading.value == true) {
    return;
  }
  if (imgCode.value == "") {
    message.error("请输入图形验证码");
    return;
  }
  const phone = ref<API.codeUsingGETParams>({
    userPhone: phoneForm.userPhone as string,
    imgCodeKey: codeMap.value.key,
    imgCode: imgCode.value,
  });
  const response = await codeUsingGet(phone.value);
  if (response.data.code === 0) {
    message.success("验证码已发送");
    loading.value = true;
    // 设置倒计时
    countdown(60);
  } else {
    message.error(response.data.message as string);
  }
};
/**
 * 图形验证码
 */
const imgCode = ref("");
const codeMap = ref<any>({
  key: "",
  image: "",
});
const getCode = async () => {
  const res = await getCodeUsingGet({
    key: codeMap.value.key,
  });
  if (res.data.code === 0) {
    codeMap.value = res.data.data;
  } else {
    message.error(res.data.message as string);
  }
};

/**
 * 倒计时
 * @param t
 */
function countdown(t: number): void {
  loading.value = true;
  const timer = t > 0 ? t : 0;
  const button = document.getElementById("getCodeButton") as any;
  button.innerText = `${timer}秒后重新获取`;
  if (timer > 0) {
    setTimeout(() => countdown(timer - 1), 1000);
  } else {
    button.innerText = `获取验证码`;
    loading.value = false;
    return;
  }
}

/**
 * 用户密码登录
 */
const form = reactive({
  userAccount: "",
  userPassword: "",
} as API.UserLoginRequest);

/**
 * 用户登录
 */
const login = async () => {
  const response = await userLoginUsingPost(form);
  if (response.data.code === 0) {
    await userStore.fetchLoginUser();
    message.success("登录成功");
    await router.push({
      path: "/",
      replace: true,
    });
  } else {
    message.error(response.data.message as string);
  }
};
/**
 * 用户注册
 */
const registerForm = reactive({
  userName: "",
  userAccount: "",
  userPassword: "",
  checkPassword: "",
} as API.UserRegisterRequest);
/**
 * 用户注册
 */
const register = async () => {
  const response = await userRegisterUsingPost(registerForm);
  if (response.data.code === 0) {
    message.success("注册成功");
    changePage(1);
  } else {
    message.error(("注册失败，" + response.data.message) as string);
  }
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
onMounted(() => {
  getCode();
});
/**
 * 切换页面
 */
const index = ref<number>(0);
const changePage = (i: number) => {
  index.value = i;
};

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_icon_phone = _resolveComponent("icon-phone")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_input_password = _resolveComponent("a-input-password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (index.value == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_typography_title, {
            heading: 5,
            style: {"margin-bottom":"20px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 手机号登录 ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_form, {
            model: phoneForm,
            "label-align": "left",
            "auto-label-width": "",
            onSubmit: phoneLogin
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { field: "userPhone" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    modelValue: phoneForm.userPhone,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneForm.userPhone) = $event)),
                    placeholder: "请输入手机号...",
                    class: "input"
                  }, {
                    suffix: _withCtx(() => [
                      _createVNode(_component_icon_phone)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { field: "phoneCode" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    modelValue: phoneForm.phoneCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneForm.phoneCode) = $event)),
                    placeholder: "请输入手机验证码...",
                    class: "input"
                  }, {
                    suffix: _withCtx(() => [
                      _createElementVNode("span", {
                        id: "getCodeButton",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (getPhoneCode()))
                      }, " 获取验证码 ")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { field: "code" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: imgCode.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((imgCode).value = $event)),
                        placeholder: "请输入验证码",
                        class: "input"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("img", {
                        style: {"width":"80px","height":"35px"},
                        src: codeMap.value.image
                      }, null, 8, _hoisted_3),
                      _createVNode(_component_a_button, {
                        id: "getCodeButton",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (getCode())),
                        class: "input"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 刷新 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                class: "input",
                style: {"width":"120px","margin":"0 auto 20px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录 / 注册 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_a_link, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (changePage(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 账户密码登录")
            ]),
            _: 1
          })
        ]))
      : (index.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_typography_title, {
              heading: 5,
              style: {"margin-bottom":"20px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 用户登录 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form, {
              model: form,
              "label-align": "left",
              "auto-label-width": "",
              onSubmit: login
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  field: "userAccount",
                  label: "账号"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: form.userAccount,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.userAccount) = $event)),
                      placeholder: "请输入账号...",
                      class: "input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  field: "userPassword",
                  tooltip: "密码不小于8位数",
                  label: "密码"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      modelValue: form.userPassword,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.userPassword) = $event)),
                      placeholder: "请输入密码...",
                      defaultVisibility: true,
                      class: "input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  style: {"width":"100px","margin":"0 auto 10px"},
                  class: "input"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_a_link, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (changePage(0)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 手机号登录")
              ]),
              _: 1
            }),
            _createVNode(_component_a_link, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (changePage(2))),
              style: {"margin-left":"220px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 去注册> ")
              ]),
              _: 1
            })
          ]))
        : (index.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_a_typography_title, {
                heading: 5,
                style: {"margin-bottom":"20px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 用户注册 ")
                ]),
                _: 1
              }),
              _createVNode(_component_a_form, {
                model: registerForm,
                "label-align": "left",
                "auto-label-width": "",
                onSubmit: register
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    field: "userName",
                    label: "名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: registerForm.userName,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((registerForm.userName) = $event)),
                        placeholder: "请输入名称...",
                        class: "input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    field: "userAccount",
                    label: "账号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        modelValue: registerForm.userAccount,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((registerForm.userAccount) = $event)),
                        placeholder: "请输入账号...",
                        class: "input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    field: "userPassword",
                    tooltip: "密码不小于8位数",
                    label: "密码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_password, {
                        modelValue: registerForm.userPassword,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((registerForm.userPassword) = $event)),
                        placeholder: "请输入密码...",
                        defaultVisibility: true,
                        class: "input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    field: "checkPassword",
                    tooltip: "密码不小于8位数",
                    label: "确认"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_password, {
                        modelValue: registerForm.checkPassword,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((registerForm.checkPassword) = $event)),
                        placeholder: "请再输入密码...",
                        defaultVisibility: true,
                        class: "input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    style: {"width":"100px","margin":"0 auto 10px"},
                    class: "input"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("注册 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_a_link, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (changePage(0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 手机号登录")
                ]),
                _: 1
              }),
              _createVNode(_component_a_link, {
                onClick: _cache[15] || (_cache[15] = ($event: any) => (changePage(2))),
                style: {"margin-left":"220px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 去登录> ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})